import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Evaluation/AlternativesSurveys/Domain/queries';
import { CriterionToAttributeMap } from '@Evaluation/AlternativesSurveys/types';
import Component from 'vue-class-component';

@Component
export default class ScoringQueries extends VueCqrs
{
	runMeetingManagerPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildMeetingManagerPageQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistMeetingPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runPanelistSurveyDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistSurveyDashboardPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runPanelistSurveyAlternativePageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: string)
	{
		const query = q.buildPanelistSurveyAlternativePageQueryV1(workspaceId, surveyId, projectUserId, alternativeId);
		this.$query(query);
	}

	runPanelistSurveyCriterionPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, criterionId: number)
	{
		const query = q.buildPanelistSurveyCriterionPageQueryV1(workspaceId, surveyId, projectUserId, criterionId);
		this.$query(query);
	}

	runScoringPanelistsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildScoringPanelistsPageQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runScoringSurveysPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildScoringSurveysPageQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}


	runScoringSurveyQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildScoringSurveyQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}



	runPanelAlternativesManagerQueryV1(surveyId: number)
	{
		const query = q.buildPanelAlternativesManagerQueryV1(surveyId);
		this.$query(query);
	}

	runSurveyAlternativeViewQueryV1(surveyId: number, votesSourceId: number, evalAlternativeId: number)
	{
		const query = q.buildSurveyAlternativeViewQueryV1(surveyId, votesSourceId, evalAlternativeId);
		this.$query(query);
	}

	runSurveyCriterionViewQueryV1(surveyId: number, votesSourceId: number, evalCriterionId: number)
	{
		const query = q.buildSurveyCriterionViewQueryV1(surveyId, votesSourceId, evalCriterionId);
		this.$query(query);
	}

	runSurveyDashboardQueryV1(surveyId: number, votesSourceId: number, isWorkspaceUser: boolean)
	{
		const query = q.buildSurveyDashboardQueryV1(surveyId, votesSourceId, isWorkspaceUser);
		this.$query(query);
	}


	runScoringPanelistsManagerQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildScoringPanelistsManagerQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runScoringPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildScoringPanelistQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runScoringAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildScoringAccessLinksBySurveyIdQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runExportScoringAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildExportScoringAccessLinksBySurveyIdQueryV1(workspaceId, surveyId);
		this.$query(query);
	}



	runScoresExporterQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildScoresExporterQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runScoresExporterPreviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, mappings: CriterionToAttributeMap[])
	{
		const query = q.buildScoresExporterPreviewQueryV1(workspaceId, projectId, evalModelId, surveyId, mappings);
		this.$query(query);
	}

	runSubSurveysManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSubSurveysManagerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runSurveyCriteriaManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSurveyCriteriaManagerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runSurveyAlternativesManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildSurveyAlternativesManagerQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runFilterAlternativesByListQueryV1(workspaceId: number, projectId: number, evalModelId: number, alternativesListId: number, viewDefId: string)
	{
		const query = q.buildFilterAlternativesByListQueryV1(workspaceId, projectId, evalModelId, alternativesListId, viewDefId);
		this.$query(query);
	}

	runAlternativeDescriptionQueryV1(workspaceId: number, projectId: number, evalModelId: number, alternativesListId: number, alternativeId: string, descriptionTemplate: string)
	{
		const query = q.buildAlternativeDescriptionQueryV1(workspaceId, projectId, evalModelId, alternativesListId, alternativeId, descriptionTemplate);
		this.$query(query);
	}

	runPanelDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildPanelDisagreementsQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildPanelConsistencyAnalysisQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}

	runPanelistConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistConsistencyAnalysisQueryV1(workspaceId, projectId, evalModelId, surveyId, projectUserId);
		this.$query(query);
	}

	runMeetingQuestionReviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, questionId: number)
	{
		const query = q.buildMeetingQuestionReviewQueryV1(workspaceId, projectId, evalModelId, surveyId, questionId);
		this.$query(query);
	}


	runPanelistVoteQueryV1(workspaceId: number, projectUserId: number, questionId: number)
	{
		const query = q.buildPanelistVoteQueryV1(workspaceId, projectUserId, questionId);
		this.$query(query);
	}
}
